/**
 * 
 */
"use strict";
angular.module('trsStripBlankModule', [])
    .filter("trsStripBlank", [function() {
        return function(str) {
            return str === null ? str : str.replace(/(  | |&nbsp;|&amp;nbsp;)+/g, "");
            // return str === null ? str : str.replace("&nbsp;", " ").replace("&amp;nbsp;"," ");

        };
    }]);
